export type OutOfAreaVariant = {
  heading: string;
  description: React.ReactNode;
  analyticsId: string;
  testId: string;
};

export default function getOutOfAreaVariant(status: {
  notAvailableInCA: boolean;
  outOfMarket: boolean;
  outOfMarketNewCar: boolean;
}): OutOfAreaVariant | null {
  if (status.outOfMarketNewCar) {
    return {
      heading: 'Brand new vehicles aren’t in your area yet',
      description: 'Change your location or browse used vehicles near you.',
      analyticsId: 'Out of Market New - Geolocation',
      testId: 'out-of-market-new-change-location'
    };
  }

  if (status.outOfMarket) {
    return {
      heading: 'We’re not in your area yet',
      description: (
        <>
          Unfortunately, we don’t currently service this area. Try changing your
          location to find an area we service near you.{' '}
          <a
            aria-label="Learn more about our service area (opens in a new tab)"
            href="/help/carvana-inventory/where-are-carvana-cars-located"
            target="_blank"
            rel="noopener noreferrer"
            className="t-link-sm"
            data-adobe-id="out-of-market-learn-more"
            data-analytics-id="Out of Market - Learn More"
            data-testid="out-of-market-learn-more"
          >
            Learn more
          </a>
        </>
      ),
      analyticsId: 'Out of Market - Geolocation',
      testId: 'out-of-market-change-location'
    };
  }

  if (status.notAvailableInCA) {
    return {
      heading: 'Not available in California',
      description:
        'We can’t verify that this vehicle meets California emissions standards, and unfortunately cannot sell it to California residents.',
      analyticsId: 'Not Available in CA - Geolocation',
      testId: 'not-available-ca-change-location'
    };
  }

  return null;
}
